// extracted by mini-css-extract-plugin
export default {"productThumbnails":"Naa-z","zoomMode":"Oaa-z","carousel":"Paa-z","slides":"Qaa-z","slide":"Raa-z","slideThumb":"Saa-z","nav":"Taa-z","mounting":"Uaa-z","horizontal":"Vaa-z"};